module.exports = __webpack_public_path__ + "img/file-attachment-03.868f6de3.svg";